/**
 * Nav contributed by this product.
 *
 * ── Derived, not restated ─────────────────────────────────────────────────
 * The platform entries come from PLATFORM_MODULES rather than being listed
 * again here. The catalog already carries a label, an icon and an href for
 * every module, and the pre-Bloom sidebar built itself the same way — so
 * writing them out a second time would create two lists that can disagree,
 * and the one that drifts is always the one nobody is looking at.
 *
 * Adding a module to the catalog now puts it in the sidebar. Removing it takes
 * it out. There is no third place to remember.
 */
import { Building2 } from 'lucide-react';
import type { NavItem } from './nav.base';
import { PLATFORM_MODULES } from './config/platform-modules';

/*
 * Customers is not a module — it is who the modules belong to — so it is listed
 * by hand while the rest derive from the catalog.
 *
 * Domains used to sit here too. Its page is gone from the UI; the mapping API
 * remains because /ssl issues certificates against the DomainMapping rows it
 * creates, so removing the endpoints would have broken SSL. Mappings are made
 * through the API now, not a screen.
 */
const CUSTOMERS: NavItem = {
  to: '/customers',
  label: 'Customers',
  icon: Building2,
  order: 50,
  // The list of everyone bloomneo runs infrastructure for. A customer's own
  // owner has no business in it, and /api/customers already refuses them.
  platformOnly: true,
};


/*
 * What one app owns - its code, uptime, backups, scheduled jobs and logs - lives in
 * that app's App deploy page, so those modules are left out of the sidebar. SSL
 * shares the Domains & SSL entry with DNS. layout.product still wraps every one of
 * their pages, which the app tabs and Servers link to for the server-wide view.
 */
const MODULES: NavItem[] = PLATFORM_MODULES.filter((module) => !module.inProject && !module.hideInNav).map((module, i) => ({
  to: module.href,
  label: module.navLabel ?? module.label,
  icon: module.icon,
  also: module.navAlso,
  // App deploy sits directly under Customers; the rest follow catalog order.
  order: module.navOrder ?? 60 + i,
}));

export const items: NavItem[] = [CUSTOMERS, ...MODULES];
